export const DATE_PRESETS = {
  ALL: "ALL_DAYS",
  CUSTOM: "CUSTOM_DAYS",
  NINETY: "PREVIOUS_90_DAYS",
  SIXTY: "PREVIOUS_60_DAYS",
  THIRTY: "PREVIOUS_30_DAYS",
};
